import { Api } from "./Api";

export default {
    copyRecurringMessages(payload)
    {
        return Api.post(`/v1/tools/copy-tools/recurring`, payload);
    },
    getCopyingStatus(jobId)
    {
        return Api.get(`/v1/tools/job-status?job_ids=${jobId}`);
    }
};